import { useEffect, useState } from 'react';
import { ProgressIndicator } from '@veneer/core';
import ModalExit from '../../components/Modals/Exit';
import { sendFinishedEvent } from '../../jarvis/eventService';
import { LocalStorageHelper } from '../../helpers/localStorage';

declare global {
  interface Window {
    isMediaclipProjectSaved: boolean;
  }
}

const ExitPage = () => {
  const [activeProjectId, setActiveProjectId] = useState('');
  const [expiresAt, setexpiresAt] = useState('');
  const [isSavedProject, setIsSavedProject] = useState(false);
  const [activeProductCategory, setActiveProductCategory] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // retrieving project data after page reload from mediaclip exit
    const projectId = LocalStorageHelper.getProjectId();
    const expiration = LocalStorageHelper.getExpiresAt();
    const device = LocalStorageHelper.getDevice();
    const productCategory = LocalStorageHelper.getCategory();

    // exiting if any project data is missing or device is not iOS
    if (!projectId || !expiration || device !== 'ios') {
      console.log('Sending FinishedEvent');
      sendFinishedEvent();
    } else {
      setActiveProjectId(projectId);
      setexpiresAt(expiration);
      const isMediaclipProjectSaved = LocalStorageHelper.getMediaclipIsSaved();
      setIsSavedProject(isMediaclipProjectSaved === 'true');
      setActiveProductCategory(productCategory || 'photobook');
      setShowModal(true);
    }
  }, []);
  return showModal ? (
    <ModalExit
      projectId={activeProjectId}
      expiresAt={expiresAt}
      isSavedProject={isSavedProject}
      productCategory={activeProductCategory}
    />
  ) : (
    <div className="spinner">
      <ProgressIndicator />
    </div>
  );
};

export default ExitPage;
